import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserLocalStorageService } from './user-local-storage.service';

export type MigrationStatus = {
  userId: string,
  migrationOpen: boolean,
  migrationInProgress: boolean,
  migrationDetails: {
    classicAlarmsSuccess: number,
    classicAlarmsFailure: number,
    customEventsSuccess: number,
    customEventsFailure: number,
    reportJobsSuccess: number,
    reportJobsFailure: number,
  } | null,
  errorType: string | null,
  errorMessage: string | null,
}


@Injectable({ providedIn: 'root' })
export class MigrationDataService {
  private http = inject(HttpClient);
  private userLocalStorageService = inject(UserLocalStorageService);

  private url = environment.APP_USERROLE_SERVICE_BASE_URL + '/api/v1/user-generated';
  private LS_HIDE_MIGRATION_PROMPT_ON_INIT = 'hide-migration-prompt-on-init';

  setDoNotAskAgainPromptOnInit(doNotAskAgain: boolean): void {
    this.userLocalStorageService.setUserValue(this.LS_HIDE_MIGRATION_PROMPT_ON_INIT, String(doNotAskAgain));
  }

  getDoNotAskAgainPromptOnInit(): boolean {
    const value = this.userLocalStorageService.getUserValue(this.LS_HIDE_MIGRATION_PROMPT_ON_INIT);
    const isTrueSet = (value === 'true');
    return isTrueSet;
  }


  // Backend API
  getMigrationStatus(): Observable<MigrationStatus> {
    return this.http.get<MigrationStatus>(`${this.url}/status`);
  }

  startMigration(): Observable<MigrationStatus> {
    return this.http.put<MigrationStatus>(`${this.url}/migrate`, null);
  }
}
